import React from 'react';
import { colors } from '../colors';

const DebugPill = (props: HtmlPropsNoRef<HTMLDivElement>): JSX.Element => (
    <div
        css={{
            backgroundColor: colors.statesSuccess,
            borderRadius: '1000px',
            padding: '4px 12px',
            margin: '8px',
            marginRight: '0',
            fontSize: '12px',
            color: 'white',
            boxShadow: '0 0 4px #0003',
            display: 'inline-block',
            zIndex: '100',
        }}
        {...props}
    />
);

export default DebugPill;
